import React from 'react';
import { CompareGrid, ErrorAlertRow, PageContainer, PageTitle, TabletHeaderSpacer } from './index.styles';
import { TextLinkBack } from '@nebula/text-link';
import PlanCards from './PlanCards';
import PlanTable from './PlanTable';
import PlanButtons from './PlanButtons';
import type { MySubscriptionContentProps, PlanId } from '../types';
import { ErrorAlert } from '@nebula/alert';

const MySubscriptionDesktopAndTablet: React.FC<MySubscriptionContentProps> = ({
  currentPlan,
  orderedPlans,
  subscriptionData,
  switchPermitted,
  errorState,
  isWebview = false,
  onSelectPlan,
  onSelectFeature,
  onBack,
  toggleManageDrawer,
  onVoucher,
}) => {
  const visibleErrors = Object.values(errorState).filter(error => Boolean(error?.show));

  return (
    <PageContainer>
      {!isWebview && onBack && <TextLinkBack onClick={onBack}>Back</TextLinkBack>}

      <CompareGrid>
        {!isWebview && <PageTitle role="heading" aria-level={1} hasError={visibleErrors.length > 0}>My subscription</PageTitle>}

        {visibleErrors.map(({ id, heading, message }) => (
          <ErrorAlertRow key={id} id={id}>
            <ErrorAlert title={heading} message={message ?? ''} showIcon />
          </ErrorAlertRow>
        ))}

        <TabletHeaderSpacer aria-hidden />

        <PlanCards orderedPlans={orderedPlans} />
        <PlanTable
          orderedPlans={orderedPlans}
          featureSections={subscriptionData.featureSections}
          onSelectFeature={onSelectFeature}
        />
        <PlanButtons
          orderedPlans={orderedPlans}
          currentPlanId={currentPlan as PlanId}
          switchPermitted={switchPermitted}
          onSelectPlan={onSelectPlan}
          toggleManageDrawer={toggleManageDrawer}
          onVoucher={onVoucher}
        />
      </CompareGrid>
    </PageContainer>
  );
};

export default MySubscriptionDesktopAndTablet;
